var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMonitor = function SvgMonitor(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#50B4A3"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M475.432,120.946v266.982c-1.703,2.832-3.459,5.622-5.256,8.37H41.83 c-4.117-6.269-7.962-12.737-11.525-19.383V120.946c0-20.731,16.541-37.595,37.157-38.107c0.313-0.01,0.637-0.01,0.961-0.01h368.891 c2.738,0,5.413,0.293,7.993,0.836C462.517,87.342,475.432,102.629,475.432,120.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M444.085,120.946v228.331H61.652V120.946c0-3.73,3.041-6.771,6.771-6.771h368.891 C441.044,114.175,444.085,117.216,444.085,120.946z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.302,
    y: 356.592,
    style: {
      fill: "#CCCCCC"
    },
    width: 445.127,
    height: 18.807
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M483.603,373.31c-11.076,21.452-25.098,41.138-41.535,58.514H69.938 c-16.436-17.377-30.459-37.063-41.535-58.514H483.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M293.618,400.477h-87.771c-15.004,0-27.167-12.164-27.167-27.167l0,0h142.106l0,0 C320.786,388.313,308.622,400.477,293.618,400.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F64C4C"
    },
    d: "M343.776,231.204c0,53.091-43.039,96.131-96.131,96.131c-13.834,0-26.99-2.926-38.881-8.192 c-33.729-14.932-57.25-48.682-57.25-87.939c0-53.091,43.039-96.131,96.131-96.131c46.853,0,85.87,33.52,94.386,77.887 C343.18,218.863,343.776,224.965,343.776,231.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56A6D6"
    },
    d: "M343.776,231.204h-96.131v-96.131C300.736,135.073,343.776,178.112,343.776,231.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD142"
    },
    d: "M343.776,231.204c0,53.091-43.039,96.131-96.131,96.131c-13.834,0-26.99-2.926-38.881-8.192 l38.881-87.939l94.386-18.244C343.18,218.863,343.776,224.965,343.776,231.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M430.502,194.632H311.384c-2.885,0-5.224-2.34-5.224-5.224s2.34-5.224,5.224-5.224h119.118 c2.885,0,5.224,2.34,5.224,5.224S433.387,194.632,430.502,194.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56A6D6"
    },
    d: "M430.502,172.689h-58.514c-2.885,0-5.224-2.34-5.224-5.224s2.34-5.224,5.224-5.224h58.514 c2.885,0,5.224,2.34,5.224,5.224S433.387,172.689,430.502,172.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M420.052,287.628H300.934c-2.885,0-5.224-2.34-5.224-5.224s2.34-5.224,5.224-5.224h119.118 c2.885,0,5.224,2.34,5.224,5.224S422.937,287.628,420.052,287.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD142"
    },
    d: "M420.052,265.685h-58.514c-2.885,0-5.224-2.34-5.224-5.224c0-2.885,2.34-5.225,5.224-5.225h58.514 c2.885,0,5.224,2.34,5.224,5.225C425.277,263.346,422.937,265.685,420.052,265.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M194.355,287.628H75.237c-2.885,0-5.224-2.34-5.224-5.224s2.34-5.224,5.224-5.224h119.118 c2.885,0,5.224,2.34,5.224,5.224S197.24,287.628,194.355,287.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F64C4C"
    },
    d: "M133.751,265.685H75.237c-2.885,0-5.224-2.34-5.224-5.224c0-2.885,2.34-5.225,5.224-5.225h58.514 c2.885,0,5.224,2.34,5.224,5.225C138.976,263.346,136.636,265.685,133.751,265.685z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMonitor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/monitor.e7da2163.svg";
export { ForwardRef as ReactComponent };